import { render, staticRenderFns } from "./TypeDisplay.vue?vue&type=template&id=9730396c&scoped=true&"
import script from "./TypeDisplay.vue?vue&type=script&lang=js&"
export * from "./TypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9730396c",
  null
  
)

export default component.exports